<template>
    <div class="base-login-form flex">
        <h2 class="login-title">
            Password reset
        </h2>
        <transition
            name="fade"
            mode="out-in"
        >
            <span v-if="!emailSuccessMessage">
                <p class="welcome-text">
                    Please enter your email address. You will receive a link to create a new password via email.
                </p>
                <form
                    id="passwordResetEmail"
                    novalidate
                    @submit.prevent="processForm"
                >
                    <fieldset
                        :class="{ error: emailErrorMessage }"
                    >
                        <input
                            id="email"
                            v-model="email"
                            type="email"
                            name="email"
                            placeholder="Email"
                            autocomplete="off"
                            :class="{ error: emailErrorMessage }"
                            @click="clearError()"
                        >
                        <label for="email">
                            Email address
                        </label>
                    </fieldset>
                    <span
                        v-if="emailErrorMessage"
                        class="form-error"
                    >
                        {{ emailErrorMessage }}
                    </span>
                    <base-form-button
                        class="btn"
                        :loading="formProcessing || false"
                    >
                        Send password reset link
                    </base-form-button>
                </form>
            </span>
            <div
                v-else
                class="password-reset-success flex"
            >
                <p>Your email with password reset link has been sent.</p>
                <i class="fas fa-check-circle" />
            </div>
        </transition>
        <a
            class="reset-link"
            @click="goToLogin"
        >
            Back to Sign In
        </a>
    </div>
</template>

<script>
import { emailValidator } from '@/utils/form/validation';
import apiCall from '@/utils/apiCall';

export default {
    data: () => ({
        email: '',
        emailErrorMessage: null,
        emailSuccessMessage: null,
        formProcessing: false,
    }),

    methods: {
        /**
         * Validate form
         *
         */
        processForm() {
            const email = this.email;

            if (! emailValidator(email)) {
                this.emailErrorMessage = 'Please enter valid email adress';

                return;
            }

            this.passwordEmail();
        },

        /**
         * Clear error data
         *
         */
        clearError() {
            this.emailErrorMessage = null;
        },

        /**
         * Call to API for reset email
         *
         */
        async passwordEmail() {
            const response = await apiCall(this, 'post', `${this.$appUrl}/api/user/password/email`, { email: this.email });

            const { status, data } = response;

            if (200 === status) {
                this.emailSuccessMessage = data.message;
            } else {
                this.emailErrorMessage = data.errors?.email[0] || data.message;
            }
        },

        /**
         * Redirect to login page
         *
         */
        goToLogin() {
            this.$router.push('/login');
        },
    },
};
</script>
